export const ConstPaths = {
  BacgroundImageFolder: '../assets/',
  MenuIconFolder: '../assets/',
  ExtremelookupUrl: 'https://extreme-ip-lookup.com/json/',
  FreegeoiplookupUrl: 'https://freegeoip.net/json/',
  IpstackUrl: 'https://api.ipstack.com/',
  IpApiUrl: 'http://ip-api.com/json/',
  FbGraphApiUrl:'https://graph.facebook.com/v3.2/',
  youtubeApiUrl: 'https://www.googleapis.com/youtube/v3/',

  //chatApiUrl: 'http://localhost:53633/api/',
  //chatHubUrl: 'http://localhost:53633/chat'

  // chatApiUrl: 'https://devf7_chat_api.app-controller.net/api/',
  // chatHubUrl: 'https://devf7_chat_api.app-controller.net/chat'

  chatApiUrl: 'https://chat-api-eu01.app-controller.net/api/',
  chatHubUrl: 'https://chat-api-eu01.app-controller.net/chat'

  // chatApiUrl: 'https://chat-api-us01.app-controller.net:4433/api/',
  // chatHubUrl: 'https://chat-api-us01.app-controller.net:4433/chat'
}



// WEBPACK FOOTER //
// ./src/config/pathConfig.js